import { FunctionComponent, useCallback, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useAuthContext } from '@/modules/Auth/contexts/AuthContext'
import { useThemeGeneratorContext } from '@/theme/contexts/ThemeGeneratorContext'
import { RenderIf } from '@/components/RenderIf'
import { useModalContext } from '@/components/Modal/contexts/ModalContext'
import { unansweredNps } from '@/modules/NPS/services'
import { useStyles } from './styles'
import { useAttendancePaymentMethod } from '@/modules/MyCalls/store/useAttendancePayment'
import { crmEvent } from '@/utils/sendCRMEvent'
import { Text } from '@conexasaude/conexa-hero'
import { Illustration } from '@/components/HideIllustrationsExternal'
import Modal from '@/components/Modal'

const CanceledByVideoErrorModal: FunctionComponent = () => {
  const [loading, setLoading] = useState(false)
  const { clinic } = useAuthContext()
  const { closeModal } = useModalContext()
  const { embed } = useThemeGeneratorContext()
  const history = useHistory()
  const styles = useStyles()

  const attendancePayment = useAttendancePaymentMethod(
    state => state.attendancePayment,
  )

  const closeModalAndSendEventbraze = useCallback(() => {
    closeModal()
    crmEvent('Modal_fechar_modal')
  }, [closeModal])

  const handleAction = useCallback(async () => {
    if (embed?.full) {
      setLoading(true)
      unansweredNps().finally(() => {
        setLoading(false)
      })
    }
    crmEvent('Modal_ok_entendi')
    closeModal()
    history.push('/')
  }, [embed?.full, closeModal, history])

  return (
    <Modal
      id="CANCELLED_BY_VIDEO_ERROR"
      onDismiss={closeModalAndSendEventbraze}
      primaryActionLabel="Ok, entendi"
      busyPrimaryAction={loading}
      opened
      primaryAction={handleAction}
      primaryActionClassName="gndi-avaliacao-confirmada"
    >
      <div>
        <div css={styles.wrapperText}>
          <RenderIf
            condition={
              clinic?.canPrivateAttendance &&
              attendancePayment !== 'CONSULTA_GRATIS'
            }
          >
            <Text>
              Parece que ocorreram problemas com o seu vídeo durante a
              videoconferência. Sua consulta foi cancelada automaticamente e o
              valor será reembolsado.
            </Text>
          </RenderIf>

          <RenderIf
            condition={
              !clinic?.canPrivateAttendance ||
              attendancePayment === 'CONSULTA_GRATIS'
            }
          >
            <Text>
              Parece que ocorreram problemas com o seu vídeo durante a
              videoconferência. Sua consulta foi cancelada automaticamente.
            </Text>
          </RenderIf>
        </div>
        <Illustration
          name="user-clock"
          css={styles.illustration}
          width="205px"
        />
        <Text css={styles.wrapperCaption}>
          Mas fique tranquilo, você poderá solicitar um novo atendimento na tela
          inicial ou agendar uma consulta.
        </Text>
      </div>
    </Modal>
  )
}

export { CanceledByVideoErrorModal }
